import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { store } from './stores/store';
import '@shopify/polaris/build/esm/styles.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import 'react-multi-carousel/lib/styles.css';

import './index.css';
import './styles/global.css';
import App from './App';
import history from 'src/routes/history';
import { initFullStory } from 'src/integrations/fullStory';
// import reportWebVitals from './reportWebVitals';

initFullStory();

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root')
);
// reportWebVitals(App);
